import React, { useState, useRef, useEffect } from "react";
import emailjs from "emailjs-com";
import { scrollToSectionId } from "../utils/scrollToSection";
import JsonData from "../data/data.json";

const initialState = {
  name: "",
  email: "",
  tel: "",
  message: "",
};

const Formsend = () => {
  const brandName = JsonData?.About?.nameBank || "RBB Capital Investimentos";
  const [{ name, email, tel, message }, setState] = useState(initialState);
  const fileRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [fileDragging, setFileDragging] = useState(false);

  const assignFile = (file) => {
    if (!file || !fileRef.current) return;
    const dt = new DataTransfer();
    dt.items.add(file);
    fileRef.current.files = dt.files;
    setFileName(file.name);
  };

  const handleChange = (e) => {
    const { name: field, value } = e.target;
    setState((prev) => ({ ...prev, [field]: value }));
  };

  const clearState = () => {
    setState({ ...initialState });
    setFileName("");
    if (fileRef.current) fileRef.current.value = "";
  };

  useEffect(() => {
    const id = window.setTimeout(() => {
      scrollToSectionId("banner-trabalhe-conosco");
    }, 80);
    return () => window.clearTimeout(id);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", e.target, "YOUR_PUBLIC_KEY")
      .then(
        () => {
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <main className="inner-page inner-page--form">
      <header
        id="banner-trabalhe-conosco"
        className="inner-page-hero inner-page-hero--compact"
      >
        <div className="container">
          <div className="inner-page-hero__text">
            <p className="inner-page-hero__eyebrow">Carreiras</p>
            <h1 className="inner-page-hero__title">Trabalhe conosco</h1>
            <p className="inner-page-hero__sub">
              Envie currículo (PDF, DOC ou DOCX) e uma mensagem. Retornamos por e-mail ou WhatsApp.
            </p>
          </div>
        </div>
      </header>

      <div className="container inner-page__body">
        <div className="form-shell form-shell--bare">
          <form
            name="sentMessage"
            className="inner-form inner-form--modern"
            onSubmit={handleSubmit}
            encType="multipart/form-data"
          >
            <div className="inner-form__grid inner-form__grid--2">
              <div className="inner-form__field">
                <label htmlFor="work-name">Nome completo</label>
                <input
                  type="text"
                  id="work-name"
                  name="name"
                  className="form-control"
                  placeholder="Nome e sobrenome"
                  value={name}
                  required
                  onChange={handleChange}
                  autoComplete="name"
                />
              </div>
              <div className="inner-form__field">
                <label htmlFor="work-email">E-mail</label>
                <input
                  type="email"
                  id="work-email"
                  name="email"
                  className="form-control"
                  placeholder="nome@email.com"
                  value={email}
                  required
                  onChange={handleChange}
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="inner-form__field">
              <label htmlFor="work-tel">Telefone ou WhatsApp</label>
              <input
                type="tel"
                id="work-tel"
                name="tel"
                className="form-control"
                placeholder="(11) 99999-0000"
                value={tel}
                required
                onChange={handleChange}
                autoComplete="tel"
              />
            </div>

            <div className="inner-form__field">
              <label htmlFor="work-cv">Currículo</label>
              <div
                className={
                  "inner-form__file-zone" +
                  (fileDragging ? " inner-form__file-zone--drag" : "")
                }
                onDragOver={(e) => {
                  e.preventDefault();
                  setFileDragging(true);
                }}
                onDragLeave={() => setFileDragging(false)}
                onDrop={(e) => {
                  e.preventDefault();
                  setFileDragging(false);
                  const f = e.dataTransfer.files?.[0];
                  if (f) assignFile(f);
                }}
              >
                <input
                  ref={fileRef}
                  type="file"
                  id="work-cv"
                  name="attachment"
                  accept=".pdf,.doc,.docx,application/pdf"
                  className="inner-form__file-input"
                  onChange={(e) =>
                    setFileName(e.target.files?.[0]?.name || "")
                  }
                />
                <div className="inner-form__file-ui" aria-hidden>
                  <span className="inner-form__file-cta">Anexar arquivo</span>
                  <span className="inner-form__file-hint">
                    {fileName || "Arraste aqui ou clique para escolher"}
                  </span>
                </div>
              </div>
            </div>

            <div className="inner-form__field">
              <label htmlFor="work-message">Mensagem</label>
              <textarea
                name="message"
                id="work-message"
                className="form-control inner-form__textarea"
                rows={5}
                placeholder="Área de interesse, experiência breve…"
                value={message}
                required
                onChange={handleChange}
              />
            </div>

            <div className="inner-form__actions">
              <p className="inner-form__fineprint">
                Ao enviar, você autoriza o contato da {brandName} sobre oportunidades.
              </p>
              <button type="submit" className="inner-form__submit">
                Enviar candidatura
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
};

export default Formsend;
